import React, { useState } from "react";
import { useHistory } from "react-router";
import { Button, Image, Col, Row, Modal, Table } from "react-bootstrap";
// import Switch from "react-switch";
// import { NavLink } from "react-router-dom";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import moment from "moment";
import SuperAdminDeleteOffer from "../../superAdminComponents/superAdminReusable/reusablePopupSuperAdmin/SuperAdminDeleteOffer";
import SimpleReactLightbox from "simple-react-lightbox";
import { SRLWrapper } from "simple-react-lightbox";

const options = {
  settings: {
    autoplaySpeed: 3000,
    disableKeyboardControls: false,
    disablePanzoom: false,
    disableWheelControls: false,
    hideControlsAfter: 3000,
    lightboxTransitionSpeed: 0.6,
    lightboxTransitionTimingFunction: "linear",
    overlayColor: "rgba(0, 0, 0, 0.9)",
    slideAnimationType: "fade",
    slideSpringValues: [300, 200],
    slideTransitionSpeed: 0.6,
    slideTransitionTimingFunction: "linear",
  },
  buttons: {
    showAutoplayButton: false,
    showCloseButton: true,
    showDownloadButton: false,
    showFullscreenButton: false,
    showNextButton: false,
    showPrevButton: false,
    showThumbnailsButton: false,
  },
  caption: {
    showCaption: false,
  },
  thumbnails: {
    showThumbnails: false,
  },
  progressBar: {
    showProgressBar: false,
  },
};

const ViewOfferDetailsOffline = (props) => {
  const history = useHistory();

  const [showMoreDetail, setShowMoreDetail] = useState(false);
  const [showView, setShowView] = useState(false);
  const handleShowView = () => {
    setShowView(true);
  };
  const handleCloseView = () => setShowView(false);
  const handleShowMoreDetail = () => {
    setShowMoreDetail({
      showMoreDetail: !showMoreDetail.showMoreDetail,
    });
  };
  // const [checked, setChecked] = useState(false);
  // const toggleFunction = (e) => {
  //   // setChecked({ checked: !checked.checked });
  //   console.log("test");
  // };
  const [showLog, setShowLog] = useState(false);
  const handleShowLog = () => {
    setShowLog({
      showLog: !showLog.showLog,
    });
  };

  const onHandleRedirect = (data) => (e) => {
    history.push({
      pathname: `/offer/edit-offline-offer/${data._id}`,
      state: { editData: data },
    });
  };

  return (
    <>
      <Button
        variant="link"
        className="enIconBtn mr-3"
        onClick={handleShowView}
      >
        <Image
          src={require("../../../assets/images/UserManagement/eye.svg")}
          alt="View"
          title="View"
          fluid
        />
      </Button>
      <Modal show={showView} onHide={handleCloseView} centered size="lg">
        <Modal.Header className="border-0 p-0 px-md-4" closeButton>
          {/* px-md-4 */}
          <Modal.Title className="f24-700">View Offer Details</Modal.Title>
        </Modal.Header>
        <hr className="m-0" />
        <Modal.Body className="p-md-4">
          <div className="pt-3 d-flex justify-content-between">
            <div>
              <div className="f12-400 opacity5">Offer Name</div>
              <div className="d-flex align-items-center pt-2">
                <div className="f16-500">
                  {props.vendorOffer && props.vendorOffer.name}
                </div>
                <div className="enPendingLBL ml-2">Offline</div>
              </div>
            </div>
            <div className="d-flex">
              <div
                className="enIconBtn mr-3"
                onClick={onHandleRedirect(props.vendorOffer)}
              >
                <Image
                  src={require("../../../assets/images/UserManagement/pencil.svg")}
                  alt="Edit"
                  title="Edit"
                  fluid
                />
              </div>
              <SuperAdminDeleteOffer
                handleCloseView={handleCloseView}
                actionBy={"vendor"}
                insideDelete={"viewDelete"}
                offerId={props.vendorOffer && props.vendorOffer._id}
                // offerId={props.vendorOffer._id}
              />
            </div>
          </div>

          <div className="pt-4 f12-400 opacity5">Description</div>
          <div className="pt-2 f12-400 w-75">
            {props.vendorOffer && props.vendorOffer.description}
          </div>
          <hr />
          <Row>
            <Col lg={3} md={6} className="my-3 border-right">
              <div className="pb-2 f12-400 opacity5">Status</div>
              <div className="d-flex align-items-center">
                <div className="f14-500 mr-2">
                  {props.vendorOffer && props.vendorOffer.active
                    ? "Active"
                    : "Inactive"}
                </div>
                {/* <Switch
                  onChange={toggleFunction}
                  checked={props.vendorOffer && props.vendorOffer.active}
                  offColor="#EEEEEE"
                  onColor="#EEEEEE"
                  offHandleColor="#212121"
                  onHandleColor="#59F832"
                  handleDiameter={24}
                  uncheckedIcon={false}
                  checkedIcon={false}
                  height={15}
                  width={41}
                  boxShadow="-2px 0px 5px #0000003B"
                  activeBoxShadow="-2px 0px 5px #0000003B"
                  id="material-switch"
                /> */}
              </div>
            </Col>
            <Col lg={3} md={6} className="my-3">
              <div className="pb-2 f12-400 opacity5">Primary Status</div>
              <div className="d-flex align-items-center">
                <div className="f14-500 mr-2">
                  {" "}
                  {props.vendorOffer && props.vendorOffer.mark_as_primary
                    ? "Yes"
                    : "No"}
                </div>
                {/* <Switch
                  onChange={toggleFunction}
                  checked={
                    props.vendorOffer && props.vendorOffer.mark_as_primary
                  }
                  offColor="#EEEEEE"
                  onColor="#EEEEEE"
                  offHandleColor="#212121"
                  onHandleColor="#59F832"
                  handleDiameter={24}
                  uncheckedIcon={false}
                  checkedIcon={false}
                  height={15}
                  width={41}
                  boxShadow="-2px 0px 5px #0000003B"
                  activeBoxShadow="-2px 0px 5px #0000003B"
                  id="material-switch"
                />
                <div className="f14-500 ml-2">Yes</div> */}
              </div>
            </Col>
          </Row>
          <hr />
          <Row>
            <Col lg={3} md={6} className="my-3 border-right">
              <div className="pb-2 f12-400 opacity5">Start Date</div>
              <div className="d-flex align-items-center">
                <Image
                  src={require("../../../assets/images/UserManagement/calendar.svg")}
                  alt="View"
                  title="View"
                  width="20px"
                  className="mr-2"
                />
                <div className="f16-700">
                  {" "}
                  {moment(
                    props.vendorOffer && props.vendorOffer.start_date
                  ).format("DD/MM/YYYY")}
                </div>
              </div>
            </Col>
            <Col lg={3} md={6} className="my-3 border-right">
              <div className="pb-2 f12-400 opacity5">Start Time</div>
              <div className="d-flex align-items-center">
                <div className="f16-700">
                  {" "}
                  {moment(
                    props.vendorOffer && props.vendorOffer.start_date
                  ).format("hh:mm A")}
                </div>
              </div>
            </Col>
            <Col lg={3} md={6} className="my-3 border-right">
              <div className="pb-2 f12-400 opacity5">End Date</div>
              <div className="d-flex align-items-center">
                <Image
                  src={require("../../../assets/images/UserManagement/calendar.svg")}
                  alt="View"
                  title="View"
                  width="20px"
                  className="mr-2"
                />
                <div className="f16-700">
                  {" "}
                  {moment(
                    props.vendorOffer && props.vendorOffer.end_date
                  ).format("DD/MM/YYYY")}
                </div>
              </div>
            </Col>
            <Col lg={3} md={6} className="my-3">
              <div className="pb-2 f12-400 opacity5">End Time</div>
              <div className="d-flex align-items-center">
                <div className="f16-700">
                  {" "}
                  {moment(
                    props.vendorOffer && props.vendorOffer.end_date
                  ).format("hh:mm A")}
                </div>
              </div>
            </Col>
            <Col lg={3} md={6} className="my-3">
              <div className="pb-2 f12-400 opacity5">Offer Code</div>
              <div className="f16-700">
                {" "}
                {props.vendorOffer && props.vendorOffer.coupon_code}
              </div>
            </Col>
            <Col lg={3} md={6} className="my-3">
              <div className="pb-2 f12-400 opacity5">Maximum Usage Limit</div>
              <div className="f16-700">
                {props.vendorOffer && props.vendorOffer.maximum_usage_limit}
              </div>
            </Col>
          </Row>
          <hr />
          <Row>
            <Col lg={3} md={6} className="my-3 border-right">
              <div className="pb-2 f12-400 opacity5">Views</div>
              <div className="f16-700">
                {props.vendorOffer && props.vendorOffer.offerViews}
              </div>
            </Col>
            <Col lg={3} md={6} className="my-3 border-right">
              <div className="pb-2 f12-400 opacity5">Used</div>
              <div className="f16-700">
                {props.vendorOffer && props.vendorOffer.offerUsed}
              </div>
            </Col>
            <Col lg={3} md={6} className="my-3">
              <div className="pb-2 f12-400 opacity5">
                Offer Code Usage Limit
              </div>
              <div className="f16-700">-</div>
            </Col>
          </Row>
          <hr />
          <div className="pb-4">
            <div className="pb-2 f12-400 opacity5">View Offer Image</div>
            <div className="d-flex flex-wrap">
              <SimpleReactLightbox>
                {((props.vendorOffer && props.vendorOffer.photos) || []).map(
                  (url, index) => (
                    <div className="enIconUploaded bg-transparent" key={index}>
                      <SRLWrapper options={options}>
                        <Image
                          src={url}
                          alt="Document"
                          className="rounded img-thumbnail"
                          fluid
                        />
                      </SRLWrapper>
                    </div>
                  )
                )}
              </SimpleReactLightbox>
            </div>
          </div>
          <div className="pb-4">
            <div className="pb-2 f12-400 opacity5">View Video</div>
            <div className="w-25">
              {console.log(props.vendorOffer)}
              {props.vendorOffer && props.vendorOffer.offerVideo === "" ? (
                ""
              ) : (
                <SimpleReactLightbox>
                  <SRLWrapper options={options}>
                    <video width="100%" height="100%" controls>
                      <source
                        src={props.vendorOffer && props.vendorOffer.offerVideo}
                        type="video/mp4"
                      />
                    </video>
                  </SRLWrapper>
                </SimpleReactLightbox>
              )}
            </div>
          </div>
          <div className="pb-4">
            <div className="f12-400 opacity5">Terms and Conditions</div>
            <div className="pt-2 f12-400 w-75">
              {props.vendorOffer && props.vendorOffer.terms_and_condition}
            </div>
          </div>
          <div className="pb-4">
            <div className="f12-400 opacity5">Refund & Cancellation</div>
            <div className="pt-2 f12-400 w-75">
              {props.vendorOffer && props.vendorOffer.refund_and_cancellation}
            </div>
          </div>
          <hr />
          <div>
            <Button
              variant="link"
              onClick={handleShowMoreDetail}
              className="f18-700 px-0 pb-3 text-dark"
            >
              View more details{" "}
              <Image
                src={require("../../../assets/images/UserManagement/up-arrow.svg")}
                alt="offer"
                title="offer"
                fluid
                width="15px"
                className={`ml-2 ${
                  !showMoreDetail.showMoreDetail ? "en180deg" : ""
                }`}
              />
            </Button>
          </div>
          {showMoreDetail.showMoreDetail && (
            <div className="enGrayBorderBox">
              <Row className="px-4">
                <Col lg={4} md={6} className="py-3">
                  <div className="f12-500 pb-3">Offer ID</div>
                  <div className="f14-400 text-break">
                    #{props.vendorOffer && props.vendorOffer._id}
                  </div>
                </Col>
                <Col lg={3} md={6} className="py-3">
                  <div className="f12-500 pb-3">Changed Date / Time</div>
                  <div className="f14-400">
                    {moment(
                      props.vendorOffer && props.vendorOffer.updatedAt
                    ).format("Do MMMM YYYY")}
                  </div>
                  <div className="f14-400">
                    {moment(
                      props.vendorOffer && props.vendorOffer.updatedAt
                    ).format("hh:mm A")}
                  </div>
                </Col>
                <Col lg={3} md={6} className="py-3 pl-4">
                  <div className="f12-500 pb-3">Created Date / Time</div>
                  <div className="f14-400">
                    {moment(
                      props.vendorOffer && props.vendorOffer.createdAt
                    ).format("Do MMMM YYYY")}
                  </div>
                  <div className="f14-400">
                    {moment(
                      props.vendorOffer && props.vendorOffer.createdAt
                    ).format("hh:mm A")}
                  </div>
                </Col>
                <Col lg={2} md={6} className="py-3 pl-4">
                  <div className="f12-500 pb-3">Point of Entry</div>
                  <div className="f14-400">
                    {props.vendorOffer && props.vendorOffer.pointOfEntry}
                  </div>
                </Col>
              </Row>
            </div>
          )}
          <hr />
          <Button
            variant="link"
            onClick={handleShowLog}
            className="f18-700 px-0 pb-3 text-dark"
          >
            View Audit Log{" "}
            <Image
              src={require("../../../assets/images/UserManagement/up-arrow.svg")}
              alt="offer"
              title="offer"
              fluid
              width="15px"
              className={`ml-2 ${!showLog.showLog ? "en180deg" : ""}`}
            />
          </Button>
          {showLog.showLog && (
            <div className="enGrayBorderBox">
              <Table responsive className="enAuditLogTBL">
                <thead>
                  <tr>
                    <th className="">
                      <div className="f12-500">Date</div>
                    </th>
                    <th>
                      <div className="f12-500">Operation</div>
                    </th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {(
                    (props.vendorOffer && props.vendorOffer.auditLogs) ||
                    []
                  ).map((data, index) => (
                    <tr key={index}>
                      <td>
                        <div className="f12-500">
                          {moment(data.timestamp).format("Do MMMM YYYY")}
                        </div>
                        <div className="f12-500">
                          {moment(data.timestamp).format("hh:mm A")}
                        </div>
                      </td>
                      <td>
                        <div className="f12-500">{data.message}</div>
                      </td>
                      <td>
                        <div className="f12-500">
                          {data.initiator === "VENDOR" ? "You" : data.initiator}
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          )}
        </Modal.Body>
      </Modal>
    </>
  );
};

ViewOfferDetailsOffline.propTypes = {
  auth: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps, null)(ViewOfferDetailsOffline);
